import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    // Empty string means "use relative URLs" — assumes a same-origin proxy
    // (Vite dev server in dev, NGINX in prod) is forwarding /api/* to the backend.
    VITE_API_BASE_URL: z.string().default(''),
    VITE_SENTRY_DSN: z.string().url().optional(),
    // Unset loads no GA4. No format check: a typo must not stop the app booting.
    VITE_GA4_MEASUREMENT_ID: z.string().optional(),
    // "Coretas Mail" web client. Unset offers no Gmail draft, only the Open in Gmail fallback.
    VITE_GMAIL_CLIENT_ID: z.string().optional(),
    // Dev-only escape hatch for the floating devtools panels.
    VITE_HIDE_TQR_DEVTOOLS: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
